<!-- 挽留弹出层 -->
<template>

  <el-dialog
    @close="dialogClose"
    :visible="isdatedetainment"
    :close-on-click-modal="zzcIsShow"
    width="30%"
    top="10vh"
  >
    <div class="vipbg">
      <div class="titleBt">
        <img src="@/assets/components/vip/jjtext.png" alt="" />
      </div>

      <div class="jj">
        <div class="jjimgContent">
          <img src="@/assets/components/vip/jj.png" alt="" />
          <div class="rc">
            <div>￥{{favorable.show_price}}</div>
            <div>￥{{favorable.show_price}}</div>
          </div>
          <div class="zj">
                ￥{{favorable.xr_price}}
          </div>
        </div>
        <div class="finally">活动最终价 ￥{{favorable.xr_price}}</div>

        <div class="jisuan">
          <div class="jisuanItem">
            <div class="itemTop">
              <span>￥</span><span class="rijg">{{favorable.show_price}}</span>
            </div>
            <div class="itemBotm">日常价格</div>
          </div>
        
          <div class="jian"></div>
          <div class="jisuanItem">
            <div class="itemTop">
              <span>￥</span><span class="rijg">{{favorable.xr_price}}</span>
            </div>
            <div class="itemBotm">优惠卷</div>
          </div>
          <div class="dengyu">
            <div></div>
            <div></div>
          </div>
          <div class="jisuanItem">
            <div class="itemTop">
              <span>￥</span><span class="rijg">{{favorable.price}}</span>
            </div>
            <div class="itemBotm">活动最终价</div>
          </div>
        </div>
      </div>

 

      <!-- 点击了立即抢购 -->
      <div class="twoEwm" v-show="btnljqg">
        <div class="wxewm">
          <div class="wxewmrq">
            <img
              style="width: 95%; height: 95%"
              st
              :src="wxzhifuerweima"
              alt=""
            />
          </div>
          <img class="zficon" src="@/assets/components/vip/wx.png" alt="" />
        </div>
        <div class="zfbewm">
          <div class="zfbwmrq">
            <iframe
              width="78%"
              height="82%"
              :src="zfbfukuanma"
              frameborder="0"
            ></iframe>
          </div>
          <img class="zficon" src="@/assets/components/vip/zfb.png" alt="" />
        </div>
      </div>

      <div >
        <div class="ljqg" @click="ljqgBtn" v-show="!btnljqg">立即抢购</div>
        <div class="crlk" @click="crlkBtn">残忍离开</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { priceTemplate, getPriceUrl,inquirePaySuces ,bingApi} from "@/api/pay";
import QRCode from "qrcode"; //生成二维码的库
import { mapGetters, mapMutations } from "vuex";
import assist from '@/utils/commonality'

export default {
  mixins: [],
  components: {},
  props: {

  },
  data() {
    return {
      btnljqg: false, //点击了立即抢购
      zzcIsShow: false, //遮罩层是否可关闭
      wxiszfbEwm: {
        wx: { url: "", out_trade_no: "" },
        ali: { url: "", out_trade_no: "" },
      },
      wxzhifuerweima: "", //微信支付的二维码
      zfbfukuanma: "", //支付宝支付的二维码
      ewmloading: false, //二维码加载状态
       timeout: 2e3,//轮询时间
      interval:null, //定时器的赋值
      times:0,// 轮询次数递增
      maxTimes:200,//最大轮询次数
      favorable:{ //价格模板的变量

      }
    };
  },
  computed: {
    ...mapGetters(["isispopvip", "isuid", "isuserInfo",'isdatedetainment']),
  },
  watch: {
   async isdatedetainment(newl) { //监听弹出层是否显示，显示了就调用获取价格模板的函数
      if (newl) {
         await this.gettemplateList()//调用获取价格模板的
      }
    },
  },
  created() {},
  mounted() {},
  methods: {
    ...mapMutations(['updatedetainment']),
   async gettemplateList() {//获取价格模板
       let res =    await  priceTemplate()
        this.favorable = res.data.list[res.data.list.length-1]
        this.getewm(this.favorable.id);
    },
    dialogClose() {//挽留弹出层的关闭 触发的方法
      this.$emit("closevippopwl");
      this.btnljqg = false;  
      this.zzcIsShow = false;
    },

    ljqgBtn() { //立即抢购btn
      this.btnljqg = true; //显示二维码
      this.zzcIsShow = true; //遮罩层可以关闭
    if (this.interval !== null) clearTimeout(this.interval);
          this.interval  =  setTimeout(() => {
                this.payisSuces();//轮询查询支付是否成功
         },this.timeout)

    },
    crlkBtn() { //残忍离开的btn
      clearTimeout(this.interval) //清除定时器
      //残忍离开btn
     this.updatedetainment(false)
    },

    async getewm(shopid) {//获取支付的二维码
      this.ewmloading = true; //开启loading加载
      try {
        let res = await getPriceUrl(shopid);
     
        this.wxiszfbEwm = res.data;
        // 生成二维码图片
        let url = await new Promise((resolve, reject) => {
          QRCode.toDataURL(res.data.wx.url, (err, url) => {
            if (err) {
              reject(err);
            } else {
              resolve(url);
            }
          });
        });
        // 设置图片的 src
        this.wxzhifuerweima = url; //微信二维码
        this.zfbfukuanma = res.data.ali.url;//支付宝二维码
        this.ewmloading = false; //加载状态结束
      } catch (error) {
        this.$tips(error.message);
      }
    },
async payisSuces() {//轮询查询是否支付成功
    try {
       let res = await inquirePaySuces(`${this.wxiszfbEwm.wx.out_trade_no},${this.wxiszfbEwm.ali.out_trade_no}`)
     
        if (res.code === 200) {
            let data = res.data;
           
            data = assist.search(data, 'status', 2, true); // 过滤状态为2的数据
            data = assist.like(data, 'payment_time', assist.date()); // 过滤支付时间为当天的数据
            if (assist.count(data) >= 1 ) { // 支付成功
                // 处理支付成功的逻辑
                console.log("支付成功");
                clearTimeout(this.interval); // 停止定时器
                this.interval = null; // 重置定时器标识
                this.times = 0; // 重置轮询次数
                //支付成功逻辑
                this.$tips("支付成功");
                this.$store.commit('updatedetainment',false)
                this.$store.dispatch('getuserinfo')
            } else if (this.times >= this.maxTimes) { // 超过最大轮询次数
                // 处理支付超时的逻辑
                clearTimeout(this.interval); // 停止定时器
                this.interval = null; // 重置定时器标识
                this.times = 0; // 重置轮询次数
                this.updatedetainment(false)
                // 在这里调用  把订单号跟价格传递给  home的bing  作业内容


                //支付超时逻辑
                this.$emit('payerror')// ！！！处理支付失败的逻辑  注意是发给父组件的
            } else {
                ++this.times; // 增加轮询次数
                this.interval = setTimeout(() => {
                    this.payisSuces(); // 继续轮询
                }, this.timeout);
            }
        } else {
            console.log('订单返回失败');
        }
    } catch (error) {
        console.error('查询支付状态时发生错误：', error);
    }
}, 


  },
};
</script>

<style scoped lang="scss">
$topsantxtcolor :#fff; //三个价格文字的颜色  
$jiagetxtcolor:#fff ;//日常价格  优惠卷  最终价格的文字颜色  
$jiandengyucolor : #fff ; //减号和等于的颜色
$buttonbackgroundcolor:linear-gradient( 224deg, #FDBF5C 0%, #F34E2D 53%, #FF356E 100%); //button的颜色  
$buttontxtcolor:#fff; // button的文字颜色
$crlitxtcolor:#fff;  //残忍离开的文字颜色

::v-deep .el-dialog {
  border-radius: 20px !important;
}
::v-deep .el-dialog__headerbtn {
  font-size: 25px !important;
  font-weight: 800 !important;
  color: #000 !important;
}
::v-deep .el-dialog__body {
  padding: 0 0 15px 0 !important;
}

.vipbg {
  padding: 20px 0;
  position: relative;
  width: 502px;
  background: url("@/assets/components/vip/wlbg.png") no-repeat;
  background-size: 100% 100%;
  margin: 0 auto;
  .titleBt {
    // padding-top: 10px;
    display: flex;
    justify-content: center;
    img {
      width: 400px;
      height: 71px;
    }
  }

  .jj {
    position: relative;
    display: flex;
    justify-content: center;
    .jjimgContent {
      width: 100%;
      position: relative;
      .zj {
       position: absolute;
    top: 41%;
    left: 43%;
    font-size: 21px;
    font-weight: 600;
    color: #ffffff;
      }
      .rc {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: space-between;
        top: 20%;
        left: 7%;
        width: 85%;
        font-weight: 600;
        div {
          color: $topsantxtcolor;
        }
      }
    }
    .finally {
      position: absolute;
      bottom: 31%;
      font-size: 18px;
      font-weight: 600;
      color: $topsantxtcolor  ;
    }
    img {
      width: 100%;
      height: 365px;
    }

    .jisuan {
      position: absolute;
      bottom: 11%;
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      padding: 0 10px;
      box-sizing: border-box;
      width: 69%;
      .jisuanItem {
        display: flex;
        flex-direction: column;
        align-items: center;
        *{
          color: $jiagetxtcolor;
        }
        .itemTop {
          font-weight: 600;
          font-size: 18px;
          .rijg {
            font-size: 25px;
          }
        }
        .itemBotm {
          font-size: 12px;
        }
      }

      .jian {
        width: 10px;
        height: 2px;
        background-color: $jiandengyucolor;
        margin: 0 5px;
      }
      .dengyu {
        div {
          width: 13px;
          height: 2px;
          background-color: $jiandengyucolor;
          margin: 5px 0;
        }
      }
    }
  }

  .ljqg {
    cursor: pointer;
    width: 216px;
    height: 54px;
    border-radius: 16px;
    text-align: center;
    line-height: 54px;
    margin: 0 auto;
    margin-top: 8px;
    color: $buttontxtcolor;
    font-weight: 600;
    font-size: 20px;
    background: $buttonbackgroundcolor;
    box-shadow: inset 0px 0 4px 0px rgba(255,255,255,0.5);
  }

  .crlk {
    cursor: pointer;
    text-align: center;
    color: $crlitxtcolor;
    font-weight: 600;
    // margin-top: 56px;
    margin-top: 14px;
    font-size: 14px;
  }

  .twoEwm {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    .wxewmrq,
    .zfbwmrq {
      width: 156px;
      height: 156px;
      border: 1px solid #000;
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .zficon {
      width: 17px;
      height: 17px;
      margin-top: 15px;
    }
  }
}
::v-deep .el-dialog__header {
  display: none;
}
::v-deep .el-dialog {
  box-shadow: 0;
  background-color: rgba(0, 0, 0, 0);
  box-shadow: 0 0px 0px rgba(0, 0, 0, 0);
}
</style>
